export const NEXO = {
  brand: "NEXO",
  tagline: "Operação de Crédito & Patrimônio",
  motto: "Onde o crédito encontra a oportunidade.",
  whatsappNumber: "5512996547030",
  whatsappDisplay: "(12) 99654-7030",
};

export const nexoWa = (msg) =>
  `https://wa.me/${NEXO.whatsappNumber}?text=${encodeURIComponent(
    msg || "Olá NEXO, quero conversar sobre minha carta contemplada e a garantia imobiliária."
  )}`;
